import { render, staticRenderFns } from "./userWithdrawalAudit.vue?vue&type=template&id=6b83b2f6&scoped=true"
import script from "./userWithdrawalAudit.vue?vue&type=script&lang=js"
export * from "./userWithdrawalAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b83b2f6",
  null
  
)

export default component.exports